const walletProvider = window.ctsautoconf.WALLET_PROVIDER
const state = window.ctsautoconf.STATE
const brand = window.ctsautoconf.BRAND
const defaultPluginURL = {
  'GEOCOMPLY': 'stg-ums.geocomply.net', // for production - ums.geocomply.com
  'LEXISNEXIS': 'https://app.radar-verify.com'
}

const defaultInstallerKey = {
  'GEOCOMPLY': 'MnRfsHYOmM'
}
const GEOLOCATION_PROVIDER = (window.ctsautoconf.GEOLOCATION && window.ctsautoconf.GEOLOCATION.PROVIDER.toUpperCase()) || 'GEOCOMPLY'
const plc = (window.ctsautoconf.GEOLOCATION && window.ctsautoconf.GEOLOCATION[GEOLOCATION_PROVIDER].PLUGIN_URL) || defaultPluginURL['GEOCOMPLY']
const gik = (window.ctsautoconf.GEOLOCATION && window.ctsautoconf.GEOLOCATION[GEOLOCATION_PROVIDER].INSTALLER_KEY) || defaultInstallerKey['GEOCOMPLY']
let geocomplyPluginVersion = (window.ctsautoconf.GEOLOCATION && window.ctsautoconf.GEOLOCATION[GEOLOCATION_PROVIDER].PLUGIN_VERSION) || '4.3.0.0'
let customFieldKey = (window.ctsautoconf.GEOLOCATION && window.ctsautoconf.GEOLOCATION[GEOLOCATION_PROVIDER].CUSTOM_KEY) || false

let providerCode, providerEWbalances, providerEWbalancesCash, providerEWbalancesBonus, providerServiceName, logout, userServiceLogin, userServiceLogout
let installerURL = plc || defaultPluginURL[GEOLOCATION_PROVIDER]
let installerKey = gik || defaultInstallerKey[GEOLOCATION_PROVIDER] // IGT as default US7 env

if (!gik) {
  switch (state) {
    case 'NJ':
      if (brand === 'sb') installerKey = 'tzp2cb0Jx2'
      break
    case 'PA':
      installerKey = 'QnEkBJRFBy'
      break
    case 'IA':
      if (brand === 'qcasino') installerKey = 'uqpUxwP3Oa'
      if (brand === 'sb') installerKey = '5vfwbE5KX1'
      break
    case 'NV':
      if (brand === 'generic-boyd') installerKey = 'm41lXY8r2P'
      if (brand === 'generic-rw') installerKey = '0fWeA6elHd'
      break
    case 'CO':
      if (brand === 'sb') installerKey = '8AyQvlNunL'
      if (brand === 'mav') installerKey = 'PmJzUkzW9R'
      break
    case 'AZ':
      if (brand === 'generic-coyotes') installerKey = 'avh91k7Xmz'
      if (brand === 'sb') installerKey = 'Lnbvk3YVxh'
      break
    case 'TN':
      if (brand === 'sb') installerKey = 'DCHWC2zVGK'
      break
    case 'RI':
      if (brand === 'generic-rilot') installerKey = 'nGw7e3it4B'
      break
    case 'VA':
      if (brand === 'sb') installerKey = 'CTfuHHzS2M'
      break
    case 'OH':
      if (brand === 'sb') installerKey = 'mPMNadhKD2'
      break
  }
}

switch (walletProvider) {
  case 'GAN':
    providerServiceName = 'ExternalWalletService'
    providerEWbalancesCash = 'CASH'
    providerEWbalancesBonus = 'CHANNEL_CREDIT'
    geocomplyPluginVersion = '3.1.1.3'
    logout = true
    break
  case 'FD':
    providerServiceName = 'FanDuelWalletService'
    providerEWbalances = 'SportsbookPlayable'
    providerEWbalancesCash = 'SportsbookPlayableCash'
    providerEWbalancesBonus = 'SportsbookBonus'
    geocomplyPluginVersion = '3.1.1.3'
    logout = true
    break
  case 'HALLEY':
    providerServiceName = 'ProbabilityService'
    providerEWbalances = 'SportsbookPlayable'
    providerEWbalancesCash = ''
    providerEWbalancesBonus = ''
    geocomplyPluginVersion = '3.1.1.3'
    logout = false
    break
  case 'SHW':
    providerCode = 'SHW'
    providerServiceName = 'userService'
    // providerEWbalances = 'SportsbookPlayable'
    // providerEWbalancesCash = 'SportsbookPlayableCash'
    // providerEWbalancesBonus = 'CHANNEL_CREDIT'
    userServiceLogin = `userServiceLogin` // This is service, not URL like for external wallets
    userServiceLogout = `userServiceLogin` // If this exist it will be used as service, if it doesn't providerServiceName will be used
    logout = true
    break
}

export default {
  providerCode,
  providerServiceName,
  balance: providerEWbalances,
  balanceCash: providerEWbalancesCash,
  balanceBonus: providerEWbalancesBonus,
  customFieldKey,
  geocomplyPluginVersion,
  installerKey,
  installerURL,
  logout,
  userServiceLogin,
  userServiceLogout
}



// WEBPACK FOOTER //
// ./src/config/walletParams.js